import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Box, Card, CardContent, Grid, Stack } from '@mui/material';
import moment from 'moment';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LedgerHeader from '../../../components/Accounts/Account/ledgerheader';
import Loader from '../../../components/Accounts/Loader';
import Report from '../../../components/Accounts/Reports/report';
import { calculateOpeningBalance, parseIntFunction } from '../../../utils/Level/utils';
import { getAllVoucherData } from '../../../utils/endPoints';

function Ledger() {
  const isMediumScreen = useMediaQuery('(min-width: 960px)');
  const level_1 = useSelector(state => state.accountLevels.level1);
  const level_2 = useSelector(state => state.accountLevels.level2);
  const level_3 = useSelector(state => state.accountLevels.level3);
  const [ledgerData, setLedgerData] = useState({});
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  async function getLedgerData(level3, startDate, endDate, site) {
    try{
      setLoading(true)
    
    startDate = moment(startDate, 'DD/MM/YYYY');
    endDate = moment(endDate, 'DD/MM/YYYY');
    const vouchers = await getAllVoucherData(
      level3.l1code,
      level3.l2code,
      level3.l3code,
    );
    vouchers.sort(function(a,b){
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(a.voucherDate) - new Date(b.voucherDate);
    });
    // vouchers.sort((a, b) => {
    //   if (a.voucherDate === b.voucherDate) {
    //     return a.voucherNumber - b.voucherNumber;
    //   }
    //   return a.voucherDate.localeCompare(b.voucherDate);
    // });
    
    console.log(vouchers);

    console.log(vouchers)

    let level3Obj = level_3.filter(obj => {
      return obj.fullcode === level3.fullcode;
    });
    let openingBalance = level3Obj[0].amount;
    console.log(level3Obj[0]);

    openingBalance = parseIntFunction(openingBalance);
    if (level3Obj[0].transactionType === 'Credit') {
      openingBalance = -openingBalance;
    }
    let oldArray = calculateOpeningBalance(vouchers, startDate);
    let ledgerData = [];
    openingBalance = openingBalance - oldArray[0] + oldArray[1];
    let balance = openingBalance;
    let totalCredit = 0;
    let totalDebit = 0;
    vouchers.forEach(data => {
      if (
        startDate.isSameOrBefore(
          moment(data.voucherDate, 'DD/MM/YYYY'),
          'day',
        ) &&
        endDate.isSameOrAfter(moment(data.voucherDate, 'DD/MM/YYYY'), 'day')
      ) {
        ledgerData.push(data);
      } else {
      }
    });

    let invoice = [];
    console.log('ledgerData: ', ledgerData);
    ledgerData.sort(function (a, b) {
      return a.voucherDate - b.voucherDate;
    });

    ledgerData.forEach(item => {
      let debit = parseIntFunction(item.debit);
      let credit = parseIntFunction(item.credit);
      console.log(balance, credit, debit, item);

      balance = balance - credit + debit;
      console.log(balance, credit, debit);

      totalCredit = totalCredit + credit;
      totalDebit = totalDebit + debit;

      let balanceString;
      if (balance > 0) {
        balanceString = Math.abs(balance).toLocaleString() + 'Dr';
      } else {
        balanceString = Math.abs(balance).toLocaleString() + 'Cr';
      }
      invoice.push({
        vouher_no: item.voucherNumber,
        date: item.voucherDate,
        type: item.type,
        desc: item.Discription,
        bill_no: item.billno,
        debit: debit.toLocaleString(),
        credit: credit.toLocaleString(),
        balance: balanceString,
      });
    });
    if (openingBalance > 0) {
      openingBalance = openingBalance.toLocaleString() + 'Dr';
    } else {
      openingBalance = Math.abs(openingBalance).toLocaleString() + 'Cr';
    }
    if (balance > 0) {
      balance = Math.abs(balance).toLocaleString() + 'Dr';
    } else {
      balance = Math.abs(balance).toLocaleString() + 'Cr';
    }
    var ledgerObj = {
      id: '617fb229f661460020535df3',
      invoice_no: '202010-93',
      invoice: invoice,
      titleData: {
        heading: 'National Bake Factory',
        title: 'Ledger',
        subTitle:
          'From ' +
          startDate.format('DD/MM/YYYY') +
          ' To ' +
          endDate.format('DD/MM/YYYY'),
        leftTitle: level3Obj[0].fullcode + ' ' + level3Obj[0].Discription,
        rightTitle: '',
        rightSubTitle: '',
      },
      docType: 'Ledger',
      from: startDate.format('DD/MM/YYYY'),
      to: endDate.format('DD/MM/YYYY'),
      codeDetails: {
        codeLevel2: level3Obj[0].fullcode.split('-')[1],
        // descLevel2: level3Obj[0].l2desc,
        codeLevel3: level3Obj[0].fullcode,
        descLevel3: level3Obj[0].Discription,
      },
      totalDebit: totalDebit.toLocaleString(),
      totalCredit: totalCredit.toLocaleString(),
      balance,
      openingBalance,
    };

    setLedgerData(ledgerObj);
    setLoading(false)
    handleOpen();
    console.log(ledgerData)
    console.log(ledgerObj)
  }
  catch{
    setLoading(false)
  }}
  

  

  return (
    <div>
    <Stack alignItems="center" spacing={1} marginTop="0rem">
    <Box sx={{ flexGrow: 0 }}>
      <Grid item xs={12} md={6}>
      <Card 
          alignItems='start'
                sx={{
                  width: "100%", 
                  marginTop: "0rem",
                  "@media (min-width: 300px)": {
                                width: 350, // Set the width to 100% for mobile view
                  },
                  "@media (min-width: 650px)": {
                                width: 650, // Set the width to 650px for screens wider than 650px
                  },
          }}
        >
    <CardContent>
        <Loader loading={loading} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop:'1rem',
          justifyContent: 'center',
          // backgroundColor: '#5CDB95',
        }}
      >
        <ToastContainer
          position="bottom-center"
          autoClose={2000}
          hideProgressBar={true}
          closeOnClick={true}
          progress={undefined}
        />

        <Typography variant="h5" component="h2" gutterBottom>
          Ledger
        </Typography>
                    <ToastContainer
                      position="bottom-center"
                      autoClose={2000}
                      hideProgressBar={true}
                      closeOnClick={true}
                      progress={undefined}
                    />
                    <LedgerHeader
                      level3Codes={level_3}
                      searchCallback={(level3, startDate, endDate, site) => {
                        getLedgerData(level3, startDate, endDate, site);
                      }}
                    ></LedgerHeader>
                    <Report
                      open={open}
                      handleClose={handleClose}
                      data={ledgerData}
                    />
            </div>
            </CardContent>
        </Card>
      </Grid>
      </Box>
      </Stack>
    </div>
  );
}

export default Ledger;
